/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var PeopleCircle1Icon24Solid = forwardRef('PeopleCircle1Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM6.244 17.19C7.144 14.22 10.31 14 12 14c1.69 0 4.856.22 5.756 3.19A7.731 7.731 0 0 1 12 19.75a7.731 7.731 0 0 1-5.756-2.56ZM12 12.25a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" })));
});
